import FamilyImage from "@/static/images/image-family-min.png";
import CVS from "@/static/images/vendor-logos/CVS.svg?url";
import Costco from "@/static/images/vendor-logos/Costco.svg?url";
import RiteAid from "@/static/images/vendor-logos/Rite_Aid.svg?url";
import Walgreens from "@/static/images/vendor-logos/Walgreens.svg?url";
import Walmart from "@/static/images/vendor-logos/Walmart.png";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Image } from "capitalrx-components-2.0/lib/general";

import styles from "./styles.module.scss";


const ParticipatingPharmacies = (): JSX.Element => {
  return (
    <section className={styles.ParticipatingPharmacies} data-testid="participating-pharmacies-section">
      <div className={styles.ParticipatingPharmaciesWrapper}>
        <div className={styles.ParticipatingPharmaciesTextWrapper}>
          <Image src={FamilyImage} alt="Woman and baby" aria-hidden="true" />
          <Paragraph className="sectionTitle" textAlign="center">Find discounts for you and your loved ones at over 65,000 pharmacies nationwide</Paragraph>
        </div>
        <div className={styles.ParticipatingPharmaciesLogos}>
          <div>

            <Image src={CVS} alt="CVS Pharmacy logo" aria-hidden="true" />
          </div>
          <div>

            <Image src={Walgreens} alt="Walgreens logo" aria-hidden="true" />
          </div>
          <div>

            <Image src={RiteAid} alt="Rite Aid logo" aria-hidden="true" />
          </div>
          <div>

            <Image src={Walmart} alt="Walmart Plus logo" aria-hidden="true" />
          </div>
          <div>

            <Image src={Costco} alt="Costco logo" aria-hidden="true" />
          </div>
        </div>
        {/* <Grid className={styles.ParticipatingPharmaciesLogos}>
          <Grid.Span columns={1} />
          <Grid.Spread columns={columns224}>
            <Image src={CVS} alt="CVS Pharmacy logo" aria-hidden="true" />
          </Grid.Spread>

          <Grid.Spread columns={columns224}>
            <Image src={Walgreens} alt="Walgreens logo" aria-hidden="true" />
          </Grid.Spread>

          <Grid.Spread columns={columns224}>
            <Image src={RiteAid} alt="Rite Aid logo" aria-hidden="true" />
          </Grid.Spread>

          <Grid.Spread columns={columns224}>
            <Image src={Walmart} alt="Walmart Plus logo" aria-hidden="true" />
          </Grid.Spread>

          <Grid.Spread columns={columns224}>
            <Image src={Costco} alt="Costco logo" aria-hidden="true" />
          </Grid.Spread>
          <Grid.Span columns={1} />
        </Grid> */}
      </div>
    </section>
  );
};

export default ParticipatingPharmacies;
